import { render, staticRenderFns } from "./SpendingCurveManger.vue?vue&type=template&id=31daad2a&scoped=true&"
import script from "./SpendingCurveManger.vue?vue&type=script&lang=js&"
export * from "./SpendingCurveManger.vue?vue&type=script&lang=js&"
import style0 from "./SpendingCurveManger.vue?vue&type=style&index=0&id=31daad2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31daad2a",
  null
  
)

export default component.exports